import { createFileRoute } from '@tanstack/react-router';
import LogoutPage from '@/pages/logout.page';

export const Route = createFileRoute('/logout/$')({
  component: LogoutPage,
});
